module.exports = __webpack_public_path__ + "static/media/truck.04f4a94a.svg";